import {
  FETCH_LICENCIA_INFO,
} from './actions.type';

import {
  SET_ERROR,
  FETCHING_LICENCIA,
  FETCHED_LICENCIA,
} from './mutations.type';
import ApiService from '../common/api.service';

/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

const state = {
  alert: false,
  alertMessage: '',
  alertType: 'success',
  alertDialog: false,
  alertDialogMessage: '',
  alertDialogType: 'success',
  loading_licencia: false,
  processing_licencia: false,
};

const getters = {
  is_loading() {
    return state.loading_licencia;
  },
  alertContainer(state) {
    return state.alert;
  },
  alertContainerMessage(state) {
    return state.alertMessage;
  },
  alertContainerType(state) {
    return state.alertType;
  },
  alertDialog(state) {
    return state.alertDialog;
  },
  alertDialogMessage(state) {
    return state.alertDialogMessage;
  },
  alertDialogType(state) {
    return state.alertDialogType;
  },
  licencia_processing() {
    return state.processing_licencia;
  },
};

const actions = {
  [FETCH_LICENCIA_INFO](context, id) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      context.commit(FETCHING_LICENCIA);
      ApiService.query(`vehiculos/licencia/${id}`)
        .then(({ data }) => {
          context.commit(FETCHED_LICENCIA);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
          context.commit(FETCHED_LICENCIA);
        });
    });
  },
};

const mutations = {
  [FETCHING_LICENCIA](state) {
    state.loading_licencia = true;
  },
  [FETCHED_LICENCIA](state) {
    state.loading_licencia = false;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
